import { useEffect, useState } from 'react';

function LoginAs() {
    const [error, setError] = useState(null);

    useEffect(() => {
        try {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.substring(1));
            const data = params.get('data');

            if (!data) {
                setError('No authentication data provided.');
                return;
            }

            const decoded = atob(data);
            const json = decodeURIComponent(escape(decoded));
            const authData = JSON.parse(json);

            if (!authData.token) {
                setError('Invalid authentication data.');
                return;
            }

            localStorage.setItem('auth', JSON.stringify(authData));
            window.location.replace('/discounts');
        } catch (e) {
            console.error('LoginAs error:', e);
            setError('Failed to process login data.');
        }
    }, []);

    if (error) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', color: 'red', fontSize: '18px' }}>
                {error}
            </div>
        );
    }

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', color: '#fff', fontSize: '18px' }}>
            Logging in...
        </div>
    );
}

export default LoginAs;
